import React from 'react';
import { Calendar, Clock, Plane, MapPin, Check, Star } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent, CardHeader } from './ui/card';
import { Badge } from './ui/badge';
import { packages, companyInfo } from '../data/mock';

const Packages = () => {
  return (
    <section id="packages" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <Badge className="mb-4 bg-[#8B0000]/10 text-[#8B0000] border-[#8B0000]/20">
            Paket Umroh Kami
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Pilihan Paket <span className="text-[#8B0000]">Umroh Terbaik</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Berbagai pilihan paket umroh dengan fasilitas terbaik dan harga terjangkau
          </p>
        </div>

        {/* Packages Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {packages.map((pkg, index) => (
            <Card 
              key={pkg.id}
              className={`group hover:shadow-2xl transition-all duration-500 border-2 overflow-hidden ${
                pkg.featured 
                  ? 'border-[#8B0000] lg:scale-105 shadow-xl' 
                  : 'border-gray-200 hover:border-[#F5C842]'
              }`}
            >
              {/* Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={pkg.image}
                  alt={pkg.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
                
                {/* Featured Badge */}
                {pkg.featured && (
                  <div className="absolute top-4 right-4">
                    <Badge className="bg-[#F5C842] text-[#8B0000] border-0 shadow-lg">
                      <Star className="w-3 h-3 mr-1 fill-current" />
                      Paket Unggulan
                    </Badge>
                  </div>
                )}

                {/* Price Tag */}
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="bg-white/95 backdrop-blur-sm rounded-xl p-4">
                    <div className="text-sm text-gray-600 mb-1">Mulai dari</div>
                    <div className="text-3xl font-bold text-[#8B0000]">{pkg.price}</div>
                  </div>
                </div>
              </div>

              <CardHeader className="pb-4">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{pkg.name}</h3>
                <p className="text-sm text-gray-600">{pkg.subtitle}</p>
              </CardHeader>

              <CardContent className="space-y-6">
                {/* Info Grid */}
                <div className="grid grid-cols-2 gap-3">
                  <div className="flex items-center space-x-2 text-sm">
                    <Clock className="w-4 h-4 text-[#8B0000]" />
                    <span className="text-gray-700">{pkg.duration}</span>
                  </div>
                  <div className="flex items-center space-x-2 text-sm">
                    <Calendar className="w-4 h-4 text-[#8B0000]" />
                    <span className="text-gray-700">{pkg.departure}</span>
                  </div>
                  <div className="flex items-center space-x-2 text-sm col-span-2">
                    <Plane className="w-4 h-4 text-[#8B0000]" />
                    <span className="text-gray-700">{pkg.airline}</span>
                  </div>
                  <div className="flex items-center space-x-2 text-sm col-span-2">
                    <MapPin className="w-4 h-4 text-[#8B0000]" />
                    <span className="text-gray-700">{pkg.route}</span>
                  </div>
                </div>

                {/* Highlights */}
                <div className="border-t border-gray-200 pt-6">
                  <h4 className="font-semibold text-gray-900 mb-3">Fasilitas Unggulan:</h4>
                  <ul className="space-y-2">
                    {pkg.highlights.map((highlight, idx) => (
                      <li key={idx} className="flex items-start space-x-2">
                        <Check className="w-4 h-4 text-[#8B0000] mt-0.5 flex-shrink-0" />
                        <span className="text-sm text-gray-700">{highlight}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* CTA Button */}
                <a 
                  href={`https://wa.me/${companyInfo.whatsapp}?text=Assalamualaikum, saya tertarik dengan paket ${pkg.name}`} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="block"
                >
                  <Button 
                    className={`w-full ${
                      pkg.featured 
                        ? 'bg-[#8B0000] hover:bg-[#A52A2A]' 
                        : 'bg-gray-900 hover:bg-gray-800'
                    } text-white transition-all duration-300 hover:scale-105`}
                    size="lg"
                  >
                    Pesan Paket Ini
                  </Button>
                </a>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <p className="text-gray-600 mb-4">Butuh konsultasi untuk memilih paket yang tepat?</p>
          <a href={`https://wa.me/${companyInfo.whatsapp}`} target="_blank" rel="noopener noreferrer">
            <Button variant="outline" size="lg" className="border-2 border-[#8B0000] text-[#8B0000] hover:bg-[#8B0000] hover:text-white">
              Konsultasi Gratis
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Packages;
